import React, {useEffect, useRef, useState} from "react"
import {
    Card,
    CardBody, CardTitle,
    Col,
} from "reactstrap"
import {connect} from "react-redux"
import {withRouter} from "react-router-dom"

import {registerLocale, setDefaultLocale} from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css"
import "assets/scss/datatables.scss"
import ptBR from "date-fns/locale/pt-BR"
import {buscarCaixasOperadores } from "../../store/auth/profile/actions"
import {Filters} from "../../common/data/definitions"
import moment from "moment-timezone"
import { describeDateTime, getCompaniesValuesByOptions } from "../../helpers/utils"
import MovimentoCaixaTable from "../MovimentoCaixa/movimento-caixa-table";
import Tooltip from "../../components/Common/tooltip"
import { withTranslation } from "react-i18next"
import { dashboardSync } from "../../store/auth/login/actions"
import Loader from "react-loader-spinner"

registerLocale("ptBR", ptBR)
setDefaultLocale("ptBR")

const UltimosMovimentoCaixaLista = props => {

    const ref = useRef()

    const [filters, setFilters] = useState(null)

    useEffect(() => {
        pesquisar(props.dashboardFilters.periodStart, props.dashboardFilters.periodEnd, props.dashboardFilters.companiesSelected)

        if(props.dashboardFilters.companiesSelected) {
            let company = getCompaniesValuesByOptions(props.dashboardFilters.companiesSelected)

            props.dashboardSync({ company: company, tabela: "TB_CAIXA" }, 'TB_CAIXA')
        }
    }, [props.dashboardFilters])

    const pesquisar = (periodStart, periodEnd, companiesSelected) => {
        const filters = []

        if(companiesSelected) {
            filters.push({id: 'idEmpresa', value: getCompaniesValuesByOptions(companiesSelected)})
        }

        if (!periodStart || !periodEnd) {
            periodStart = moment().startOf("month").format("YYYY-MM-DD 00:00:00")
            periodEnd = moment().endOf("month").format("YYYY-MM-DD 23:59:59")
        }

        filters.push({id: 'Data_Abertura', value: periodStart, condition: Filters.greaterThanOrEqualTo})
        filters.push({id: 'Data_Abertura', value: periodEnd, condition: Filters.lessThanOrEqualTo})

        setFilters(filters)

        setTimeout(() => ref?.current?.search(), 300)
    }

    return (
        <React.Fragment>
            <Col>
                <div>
                    <Card>
                        <CardBody>
                            {props.loadingDashboardSyncTB_CAIXA ?
                              <div className="loader-container position-absolute">
                                  <Loader
                                    type="ThreeDots"
                                    color="#556EE6"
                                    height={80}
                                    width={80}
                                  />
                              </div>
                              :
                              <div className="clearfix">
                                  <h4 className="card-title mb-4">{props.t("dashboard.transactions")}
                                      <Tooltip id="evolucaovendas"
                                               tooltip={props.t("dashboard.lista.evolucaovendas.tooltip")}></Tooltip>
                                      <p
                                        className="card-sync">{props.dashboardSyncTB_CAIXA?.error ? props.t('dashboard.lista.sinc.tooltip.error') :
                                        props.t("dashboard.lista.sinc.tooltip", { data: describeDateTime(props.dashboardSyncTB_CAIXA) })
                                        }</p>
                                  </h4>
                              </div>
                            }
                            <CardTitle className="mb-4">
                            </CardTitle>
                            <MovimentoCaixaTable ref={ref} filters={filters} history={props.history}>
                            </MovimentoCaixaTable>
                        </CardBody>
                    </Card>
                </div>
            </Col>
        </React.Fragment>
    )
}

UltimosMovimentoCaixaLista.propTypes = {}

const mapStatetoProps = state => {
    const { user, dashboardFilters, loadingDashboardSyncTB_CAIXA, dashboardSyncTB_CAIXA } = state.Login
    return { user, dashboardFilters, loadingDashboardSyncTB_CAIXA, dashboardSyncTB_CAIXA }
}

export default withTranslation()(connect(mapStatetoProps, {dashboardSync})(withRouter(UltimosMovimentoCaixaLista)))
